export default { sha: '48c21de3fe0284f9c071af3bbac4cb02ed31f118', buildNumber: 'undefined' }
